import {
  REQUEST_LOWERBOUND,
  REQUEST_UPPERBOUND,
  NUMBER_OF_NEXT_ITINERARIES,
  STANDALONE_REQUEST,
} from '../../../../constants/constants'

class AirSearchRequestModel {
  constructor(model = {}) {
    const {
      modelInitialized,
      client,
      requestId,
      searchId,
      clientSessionId,
      itineraryType,
      searchSessionKey,
      cache,
      slices,
      seti,
      expFlags,
      plfCode,
      filter,
      passengers,
      displayParameters,
      searchOptions,
      expressDeal,
      referrals,
      isUSOnly,
      appCode,
      requestType,
      packageSearchQuery,
      clientCountryCode,
    } = model

    this.modelInitialized = !!modelInitialized // Used as a flag to create Initial search object
    this.client = client || 'PCLN_FLIGHTS'
    this.requestId = requestId || null
    this.searchId = searchId || null
    this.clientSessionId = clientSessionId || null
    this.itineraryType = itineraryType || null
    this.searchSessionKey = searchSessionKey || null
    this.cache = cache || null
    this.slices = slices || []
    this.seti = seti || {}
    this.expFlags = expFlags || {}
    this.plfCode = plfCode || 'PCLN'
    this.isFireFly = true
    this.isUSOnly = isUSOnly
    this.appCode = appCode
    this.requestType = requestType || STANDALONE_REQUEST
    this.packageSearchQuery = packageSearchQuery || {}

    this.filter = filter || {
      sliceFilters: [],
      exactDateFilters: null,
    }
    /**
     * This is mostly for reference and will be overridden during the
     *  initial build request
     * */
    this.passengers = passengers || {
      adults: 0,
      children: 0,
      infants: 0,
      seniors: 0,
    }
    this.displayParameters = displayParameters || {
      sliceRefId: [1],
      lowerBound: REQUEST_LOWERBOUND,
      upperBound: REQUEST_UPPERBOUND,
    }
    this.searchOptions = searchOptions || {
      preferredCarriers: null,
      excludedCarriers: null,
      maxLayoverDurationInMinutes: null,
      stopsFilterType: null,
      jetOnly: false,
      cabinClass: 'ECO',
      includeFusedItineraries: true, // TODO: remove in separate story
      upsell: false,
      enablePreferredCabinClass: false,
      numOfRenderedListings: null,
    }
    this.includeFareBasisCode = true
    this.expressDeal = expressDeal || {
      // Allow Alternate Airports
      allowAltAirports: true,
      openJawAllowed: true,
      includeFused: true,
    }
    this.referrals = referrals || []
    this.mergeItineraryList = true
    this.clientCountryCode = clientCountryCode || ''
  }

  /**
   * LowerBound and UpperBound needs to be reset when calling filters
   *  and update then for loadMore options
   * */
  setDisplayParams({ lowerBound, upperBound }) {
    this.displayParameters.lowerBound = lowerBound
    this.displayParameters.upperBound = upperBound
  }

  setSliceRefId({ sliceRefId }) {
    this.displayParameters.sliceRefId = sliceRefId
  }

  setSearchSessionKey({ searchSessionKey }) {
    this.searchSessionKey = searchSessionKey
  }

  setSearchId({ searchId }) {
    this.searchId = searchId
  }

  setItineraryType({ itineraryType }) {
    this.itineraryType = itineraryType
  }

  setSliceFilters({ sliceFilters }) {
    if (Array.isArray(sliceFilters)) {
      this.filter.sliceFilters = sliceFilters
    }
  }

  clearExactDateFilters() {
    this.filter.exactDateFilters = null
  }

  setExactDateFilters({ exactDateFilters }) {
    if (Array.isArray(exactDateFilters)) {
      this.filter.exactDateFilters = exactDateFilters
    }
  }

  /**
   * This is called on every response of airSearch call
   * */
  setParams({ response }) {
    const { listingsMetaData } = response

    if (listingsMetaData?.upperBound) {
      this.setDisplayParams({
        lowerBound: listingsMetaData.upperBound + 1,
        upperBound: listingsMetaData.upperBound + NUMBER_OF_NEXT_ITINERARIES,
      })
    }

    if (!this.searchSessionKey && listingsMetaData?.searchSessionKey) {
      this.searchSessionKey = listingsMetaData.searchSessionKey
    }
  }
}

export { AirSearchRequestModel }
